import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=55c03a6a&scoped=true&"
import script from "./ui-button.vue?vue&type=script&lang=js&"
export * from "./ui-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c03a6a",
  null
  
)

export default component.exports